/* Seek Key — Hover Video Preview (v4 — load only on hover, no preloading) */
(function() {
  "use strict";

  // Desktop only — skip touch devices and low-end hardware
  if (window.matchMedia("(hover: none)").matches) return;
  if (navigator.deviceMemory && navigator.deviceMemory < 4) return;
  var conn = navigator.connection || navigator.mozConnection;
  if (conn && (conn.saveData || conn.effectiveType === "slow-2g" || conn.effectiveType === "2g")) return;

  function initHoverVideos() {
    document.querySelectorAll(".card-wrapper").forEach(function(card) {
      if (card._hoverVideoInit) return;
      card._hoverVideoInit = true;
      var video = card.querySelector(".hover-video-steam");
      if (!video) return;
      if (video.offsetParent === null) return;

      card.addEventListener("mouseenter", function() {
        // Load src only on first hover — no preloading
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src;
        }
        if (!video.src) return;

        if (video.readyState >= 2) {
          video.currentTime = 0;
          video.play().catch(function(){});
        } else {
          video.load();
          var loadTimeout = setTimeout(function() { loadTimeout = null; }, 4000);
          video.addEventListener("canplay", function onCanPlay() {
            video.removeEventListener("canplay", onCanPlay);
            if (loadTimeout) { clearTimeout(loadTimeout); loadTimeout = null; }
            video.play().catch(function(){});
          });
        }
      });

      card.addEventListener("mouseleave", function() {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHoverVideos);
  } else {
    initHoverVideos();
  }
  document.addEventListener("shopify:section:load", initHoverVideos);

  // MutationObserver: detect dynamically added cards
  if ("MutationObserver" in window) {
    var domObserver = new MutationObserver(function(mutations) {
      var hasNewCards = false;
      mutations.forEach(function(m) {
        if (m.addedNodes.length) {
          m.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.classList && node.classList.contains("card-wrapper") || node.querySelector && node.querySelector(".card-wrapper"))) {
              hasNewCards = true;
            }
          });
        }
      });
      if (hasNewCards) initHoverVideos();
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }
})();